module.exports = __webpack_public_path__ + "static/media/reedJPFood1014.0ea70163.ico";